import { createTheme } from "@mui/material/styles";

// Tema claro MUI: mesma estrutura do muiTheme (escuro), com fundos claros e
// texto escuro. Cores de marca (azul primário) permanecem iguais.
const muiThemeClaro = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#2196f3",
      dark: "#0056b3",
      contrastText: "#fff",
    },
    error: {
      main: "#e53935",
    },
    warning: {
      main: "#f59e0b",
    },
    success: {
      main: "#22c55e",
    },
    background: {
      default: "#f3f4f6",
      paper: "#ffffff",
    },
    text: {
      primary: "#1f2937",
      secondary: "#4b5563",
    },
    divider: "#d1d5db",
  },
  typography: {
    fontFamily: "'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif",
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: "#ffffff",
          color: "#1f2937",
          fontWeight: 600,
        },
        body: {
          color: "#1f2937",
          borderBottomColor: "#d1d5db",
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&:hover": { backgroundColor: "rgba(0,0,0,0.04)" },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& fieldset": { borderColor: "#c4c8ce" },
          "&:hover fieldset": { borderColor: "#9ca3af" },
        },
        input: { color: "#1f2937" },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: { color: "#4b5563" },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { textTransform: "none", fontWeight: 500 },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: "none" },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: { backgroundColor: "#ffffff" },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: { color: "#1f2937", borderTop: "1px solid #d1d5db" },
        selectIcon: { color: "#1f2937" },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          "& .MuiAutocomplete-clearIndicator": { color: "rgba(17,24,39,0.6)" },
          "& .MuiAutocomplete-popupIndicator": { color: "rgba(17,24,39,0.6)" },
          "& .MuiAutocomplete-endAdornment button": { color: "rgba(17,24,39,0.6)" },
        },
        paper: { backgroundColor: "#ffffff" },
        option: { color: "#1f2937", "&:hover": { backgroundColor: "rgba(0,0,0,0.05)" } },
        noOptions: { color: "rgba(17,24,39,0.5)" },
      },
    },
  },
});

export default muiThemeClaro;
